import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getImageUrl, toArray } from "../../helpers/common";
import useStyles from "./styles";

export default function ProductAccordion({ product, tabRef }) {
  const [imgExist, setImgExist] = React.useState(false);
  const classes = useStyles();

  React.useEffect(() => {
    if (product.description && product.description.includes("<img")) {
      setImgExist(true);
    } else {
      setImgExist(false);
    }
  }, [product?.description]);

  const getList = (list) => {
    let listArr = toArray(list, "\n");
    return listArr.map((h) => <li key={h.id}>{h}</li>);
  };

  return (
    <div ref={tabRef} className="w-100 mt-4">
      <div className="">
        <Accordion className={classes.accordionItem}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="description-content"
            id="description-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.accordionTitle}>
              Description
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.descriptionSec}>
              <ul className={classes.descriptionUl}>
                {product.highlights
                  ? getList(product.highlights)
                  : "No value found"}
              </ul>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className={classes.accordionItem}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="nutrition-content"
            id="nutrition-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.accordionTitle}>
              Nutrition & Ingredients
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            {!product.description && !product?.attributes
              ? "No value found"
              : null}

            <div className={classes.nutritionRow}>
              {product?.description || imgExist ? (
                <div className={classes.nutiLeftCol}>
                  {imgExist ? (
                    <div>
                      <img
                        className={classes.nutritionImg}
                        src={getImageUrl(product?.description)}
                        alt="nutrition-img"
                      />
                    </div>
                  ) : (
                    product?.description?.replace(/(<([^>]+)>)/gi, "")
                  )}
                </div>
              ) : null}

              {(product?.description || imgExist) && product?.attributes ? (
                <div className={classes.divider}></div>
              ) : null}

              <div className={classes.nutiRightCol}>
                {/* ingredients */}
                {product?.attributes && (
                  <div className={classes.ingredientsSec}>
                    {/* <p className={classes.ingredientsText}>Ingredients:</p> */}
                    <p className={classes.ingredientsValue}>
                      {" "}
                      {product.attributes
                        ? getList(product.attributes)
                        : "No value found"}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className={classes.accordionItem}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="shipping-content"
            id="shipping-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.accordionTitle}>
              Shipping Information
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.descriptionSec}>
              <p className={classes.accordionText}>
                Delivering PAN India. Minimum Order Value ₹400/- || Estimated
                Standard Delivery Timeline of 5-7 Working Days, Though Delivery
                Time May Vary Depending On Pin Code.
              </p>
              <p className={classes.accordionText}>
                For detailed shipping information, please visit our{" "}
                <a
                  href="https://avonnamkeen.com/pages/Shipping"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.accordionLink}
                >
                  Shipping Policy
                </a>{" "}
                page.
              </p>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className={classes.accordionItem}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="cancellation-content"
            id="cancellation-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.accordionTitle}>
              Cancellation Policy
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.descriptionSec}>
              <p className={classes.accordionText}>
                We accept cancellations made before the cut-off time of our shipping slot (3 hours). 
                Please reach out to our customer services for cancellation requests and refunds.
              </p>
              <p className={classes.accordionText}>
                We refund all payments made for orders placed as store credit, which can be used 
                for future purchases. For detailed information, please visit our{" "}
                <a
                  href="https://avonnamkeen.com/pages/cancellation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.accordionLink}
                >
                  Cancellation Policy
                </a>{" "}
                page.
              </p>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className={classes.accordionItem}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="faq-content"
            id="faq-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.accordionTitle}>
              Frequently Asked Questions
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.descriptionSec}>
              <div style={{ marginBottom: "20px" }}>
                <h4 className={classes.accordionHeading}>
                  How do I track my order?
                </h4>
                <p className={classes.accordionParagraph}>
                  You can track your order using the tracking number sent to
                  your email, or by logging into your account and checking the
                  order status.
                </p>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <h4 className={classes.accordionHeading}>
                  What payment methods do you accept?
                </h4>
                <p className={classes.accordionParagraph}>
                  We accept all major credit cards, PayPal, Apple Pay, Google
                  Pay, and bank transfers.
                </p>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <h4 className={classes.accordionHeading}>
                  Can I cancel my order?
                </h4>
                <p className={classes.accordionParagraph}>
                  Yes, you can cancel your order before the cut-off time of our shipping slot (3 hours). 
                  Please contact our customer services for cancellation requests. Refunds are processed as store credit.
                </p>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
